import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  *,\n  *:before,\n  *:after {\n    box-sizing: border-box;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  transition: background 250ms ease;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n      opacity: 1;\n      visibility: visible;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n      height: 100vh;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import styled, { css, ThemeProvider } from "styled-components";
import theme from "./theme";
import HeaderLogo from "./components/HeaderLogo";
import { Box, checkUserInfo, Hide, Link, LanguageSwitcher, useWindowSize } from "@miro-site/core";
import ContactSalesLink from "./components/ContactSalesLink";
import TopNavigation from "./components/TopNavigation";
import CtaNavigation from "./components/CtaNavigation";
import BurgerMenu from "./components/BurgerMenu";
import AccordionMenu from "./components/AccordionMenu";
import HeaderContainer from "./components/HeaderContainer";
import SecondaryNavigationContainer from "./components/SecondaryNavigationContainer";
import NavigationOverlay from "./components/NavigationOverlay";
import { usePageTranslations } from "@miro-site/localization";
import { useLocalization } from "@miro-site/localization";
import { isDarkTheme } from "./utils";
var StyledHeader = styled(Box).attrs({
    as: "header",
    $styles: {
        fontFamily: "Formular",
        fontFeatureSettings: "'ss03'"
    }
}).withConfig({
    componentId: "sc-5aa2f807-0"
})(_templateObject());
StyledHeader.displayName = "StyledHeader";
var HeaderRoot = styled(Box).attrs(function(param) {
    var $isMobileMenuOpened = param.$isMobileMenuOpened, $appearance = param.$appearance, header = param.theme.header;
    return {
        $styles: {
            zIndex: 10,
            position: "relative",
            background: $isMobileMenuOpened || isDarkTheme($appearance) ? theme.header.backgroundDark : theme.header.background,
            borderBottom: isDarkTheme($appearance) ? "none" : header.secondaryNavigation.stroke,
            color: isDarkTheme($appearance) ? theme.header.colors.white : theme.header.colors.indigo
        }
    };
}).withConfig({
    componentId: "sc-5aa2f807-1"
})(_templateObject1());
var HeaderNav = styled(Box).attrs(function(param) {
    var theme = param.theme;
    return {
        as: "nav",
        $styles: {
            position: "relative",
            height: theme.header.height,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            flexFlow: "row nowrap",
            paddingRight: theme.header.navigation.padding.right
        }
    };
}).withConfig({
    componentId: "sc-5aa2f807-2"
})(_templateObject2(), LanguageSwitcher.SwitcherCurrentLocale, function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        fontSize: theme.header.topNavigation.fontSize,
        lineHeight: theme.header.topNavigation.lineHeight,
        display: [
            "block",
            "block",
            "none",
            "block",
            "block"
        ]
    });
});
var AccordionMobileContainer = styled(Box).attrs(function(param) {
    var theme = param.theme, $isMobileMenuOpened = param.$isMobileMenuOpened;
    return {
        $styles: {
            background: "primaryIndigo",
            overflowY: "auto",
            position: "absolute",
            top: theme.header.height,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0,
            visibility: "hidden",
            transition: "opacity 250ms ease, visibility 250ms ease"
        }
    };
}).withConfig({
    componentId: "sc-5aa2f807-3"
})(_templateObject4(), function(param) {
    var $isMobileMenuOpened = param.$isMobileMenuOpened;
    return $isMobileMenuOpened && css(_templateObject3());
});
var HeaderWrapper = styled(Box).withConfig({
    componentId: "sc-5aa2f807-4"
})(_templateObject6(), function(param) {
    var $isMobileMenuOpened = param.$isMobileMenuOpened;
    return $isMobileMenuOpened && css(_templateObject5());
});
var MobileControls = styled(Box).attrs({
    $styles: {
        textAlign: "center",
        paddingTop: 64,
        paddingBottom: 36
    }
}).withConfig({
    componentId: "sc-5aa2f807-5"
})(_templateObject7());
var MobileLinksContainer = styled(Box).attrs({
    $styles: {
        marginTop: 23,
        marginBottom: 20
    }
}).withConfig({
    componentId: "sc-5aa2f807-6"
})(_templateObject8());
var MobileLink = styled(Link).attrs({
    $mx: 10
}).withConfig({
    componentId: "sc-5aa2f807-7"
})(_templateObject9());
var LanguageSwitcherContainer = styled(Box).attrs({
    $styles: {
        display: "flex",
        justifyContent: "center"
    }
}).withConfig({
    componentId: "sc-5aa2f807-8"
})(_templateObject10());
var LoginLink = styled(Link).attrs(function(param) {
    var $appearance = param.$appearance, theme = param.theme;
    return {
        $styles: {
            fontSize: theme.header.topNavigation.fontSize,
            lineHeight: theme.header.topNavigation.lineHeight,
            display: "block",
            color: "inherit",
            ":hover": {
                color: isDarkTheme($appearance) ? theme.colors.outspoken : theme.header.topNavigation.hoverColor
            }
        }
    };
}).withConfig({
    componentId: "sc-5aa2f807-9"
})(_templateObject11(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        ":focus": _object_spread({}, theme.focus.outlines.withOffset)
    });
});
var Header = function(props) {
    var label = props.label, productNavigation = props.productNavigation, solutionsNavigation = props.solutionsNavigation, resourcesNavigation = props.resourcesNavigation, enterpriseLink = props.enterpriseLink, pricingLink = props.pricingLink, contactSalesLink = props.contactSalesLink, loginLink = props.loginLink, dashboardButton = props.dashboardButton, signupButton = props.signupButton, bottomLinks = props.bottomLinks, customerSpotlight = props.customerSpotlight, templates = props.templates, whatsNew = props.whatsNew, _containerNode = props.containerNode, containerNode = _containerNode === void 0 ? null : _containerNode, _appearance = props.appearance, appearance = _appearance === void 0 ? "light" : _appearance, className = props.className;
    var mobileMenuData = [
        productNavigation,
        solutionsNavigation,
        resourcesNavigation,
        enterpriseLink,
        pricingLink, 
    ];
    var ref = useState(), userId = ref[0], setUserId = ref[1];
    var ref1 = useState(false), isMobileMenuOpened = ref1[0], setIsMobileMenuOpened = ref1[1];
    var ref2 = useState(null), activeNavigation = ref2[0], setActiveNavigation = ref2[1];
    var ref3 = _sliced_to_array(usePageTranslations(), 2), switcherData = ref3[0], onChangeLocale = ref3[1].onChangeLocale;
    var width = useWindowSize().width;
    var currentLocale = useLocalization().currentLocale;
    var isRUlocale = currentLocale == "ru" ? true : false;
    var isMobileScreen = typeof width === "number" && width <= theme.breakpoints.v2Tablet;
    var activeNavigationRef = useRef(null);
    useEffect(function() {
        var ref = checkUserInfo() || {}, tmp = ref.id, userId = tmp === void 0 ? 0 : tmp;
        setUserId(userId);
    }, []);
    useEffect(function() {
        if (containerNode) {
            if (isMobileMenuOpened) {
                containerNode.classList.add("mobile-menu-opened");
            } else {
                containerNode.classList.remove("mobile-menu-opened");
            }
        }
        document.body.style.overflow = isMobileMenuOpened ? "hidden" : "";
    }, [
        isMobileMenuOpened
    ]);
    var toggleNavigation = function(navigation) {
        setActiveNavigation(function(current) {
            return current === navigation ? null : navigation;
        });
    };
    return /*#__PURE__*/ _jsx(ThemeProvider, {
        theme: function(defaultTheme) {
            return _object_spread({}, defaultTheme, theme);
        },
        children: /*#__PURE__*/ _jsxs(StyledHeader, {
            "data-place": "Header",
            className: className,
            children: [
                /*#__PURE__*/ _jsx(HeaderRoot, {
                    $appearance: appearance,
                    $isMobileMenuOpened: isMobileMenuOpened,
                    children: /*#__PURE__*/ _jsx(HeaderContainer, {
                        children: /*#__PURE__*/ _jsxs(HeaderWrapper, {
                            $isMobileMenuOpened: isMobileMenuOpened,
                            children: [
                                /*#__PURE__*/ _jsxs(HeaderNav, {
                                    "aria-label": label,
                                    children: [
                                        /*#__PURE__*/ _jsx(HeaderLogo, {
                                            href: "/",
                                            color: isMobileMenuOpened || isDarkTheme(appearance) ? "white" : "primaryIndigo"
                                        }),
                                        !isMobileMenuOpened && /*#__PURE__*/ _jsx(TopNavigation, {
                                            onToggleNavigation: toggleNavigation,
                                            activeNavigationRef: activeNavigationRef,
                                            activeNavigation: activeNavigation,
                                            productNavigation: productNavigation,
                                            solutionsNavigation: solutionsNavigation,
                                            resourcesNavigation: resourcesNavigation,
                                            templates: templates,
                                            customerSpotlight: customerSpotlight,
                                            whatsNew: whatsNew,
                                            enterpriseLink: enterpriseLink,
                                            pricingLink: pricingLink,
                                            appearance: appearance
                                        }),
                                        !isMobileMenuOpened && /*#__PURE__*/ _jsxs(CtaNavigation, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Hide, {
                                                    $on: [
                                                        "v2Mobile"
                                                    ],
                                                    children: switcherData && /*#__PURE__*/ _jsx(LanguageSwitcher, _object_spread({
                                                        color: isDarkTheme(appearance) ? "white" : undefined,
                                                        onSelect: function(e, link) {
                                                            onChangeLocale(link.locale);
                                                        }
                                                    }, switcherData))
                                                }),
                                                /*#__PURE__*/ _jsx(Hide, {
                                                    $on: [
                                                        "v2Mobile"
                                                    ],
                                                    children: isRUlocale ? null : /*#__PURE__*/ _jsx(ContactSalesLink, {
                                                        href: contactSalesLink.path,
                                                        label: contactSalesLink.title,
                                                        appearance: appearance
                                                    })
                                                }),
                                                userId !== undefined && userId === 0 && /*#__PURE__*/ _jsx(Hide, {
                                                    $on: [
                                                        "v2Mobile"
                                                    ],
                                                    children: /*#__PURE__*/ _jsx(LoginLink, {
                                                        href: loginLink.path,
                                                        $color: "default",
                                                        $size: "default",
                                                        $appearance: appearance,
                                                        children: loginLink.title
                                                    })
                                                }),
                                                userId !== undefined && (userId > 0 ? /*#__PURE__*/ _jsx(CtaNavigation.Button, {
                                                    href: dashboardButton.path,
                                                    children: dashboardButton.title
                                                }) : /*#__PURE__*/ _jsx(CtaNavigation.Button, {
                                                    href: signupButton.path,
                                                    needReferer: true,
                                                    children: signupButton.title
                                                }))
                                            ]
                                        }),
                                        (isMobileMenuOpened || isMobileScreen) && /*#__PURE__*/ _jsx(BurgerMenu, {
                                            appearance: appearance,
                                            onClick: function() {
                                                setIsMobileMenuOpened(!isMobileMenuOpened);
                                            },
                                            $isMobileMenuOpened: isMobileMenuOpened
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(AccordionMobileContainer, {
                                    "data-track-place": "Header",
                                    $isMobileMenuOpened: isMobileMenuOpened,
                                    children: [
                                        /*#__PURE__*/ _jsx(AccordionMenu, {
                                            categories: mobileMenuData
                                        }),
                                        isMobileScreen && /*#__PURE__*/ _jsxs(MobileControls, {
                                            children: [
                                                userId !== undefined && (userId > 0 ? /*#__PURE__*/ _jsx(CtaNavigation.Button, {
                                                    href: dashboardButton.path,
                                                    $isMobileButton: true,
                                                    children: dashboardButton.title
                                                }) : /*#__PURE__*/ _jsx(_Fragment, {
                                                    children: /*#__PURE__*/ _jsx(CtaNavigation.Button, {
                                                        href: signupButton.path,
                                                        needReferer: true,
                                                        $isMobileButton: true,
                                                        children: signupButton.title
                                                    })
                                                })),
                                                /*#__PURE__*/ _jsxs(MobileLinksContainer, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(MobileLink, {
                                                            href: loginLink.path,
                                                            $color: "white",
                                                            $size: "default",
                                                            children: loginLink.title
                                                        }),
                                                        isRUlocale ? null : /*#__PURE__*/ _jsx(MobileLink, {
                                                            href: contactSalesLink.path,
                                                            $color: "white",
                                                            $size: "default",
                                                            children: contactSalesLink.title
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(LanguageSwitcherContainer, {
                                                    children: switcherData && /*#__PURE__*/ _jsx(LanguageSwitcher, _object_spread_props(_object_spread({}, switcherData), {
                                                        onSelect: function(e, link) {
                                                            onChangeLocale(link.locale);
                                                        },
                                                        color: "white",
                                                        position: "top"
                                                    }))
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                !isMobileScreen && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(SecondaryNavigationContainer, {
                            isFixed: false,
                            activeNavigation: activeNavigation,
                            activeNavigationRef: activeNavigationRef,
                            bottomLinks: bottomLinks
                        }),
                        /*#__PURE__*/ _jsx(NavigationOverlay, {
                            onClick: function() {
                                return setActiveNavigation(null);
                            },
                            $isActive: activeNavigation !== null
                        })
                    ]
                })
            ]
        })
    });
};
export default Header;
